
import { NDescriptions, NDescriptionsItem, NSpin } from 'naive-ui';
import { mapState } from 'pinia';
import { defineComponent } from 'vue';

import ComponentBase from '~/components/component-base';
import ChartNetwork from "~/components/chart-network/chart-network.vue";


import { useStationDetailStore } from '~/store/station-details.store';

export default defineComponent({

    extends: ComponentBase,

    components: {
        NDescriptions,
        NDescriptionsItem,
        NSpin,

        ChartNetwork,
    },

    computed: {
         ...mapState(useStationDetailStore, ['station', 'measures', 'since', 'before']),

        networkType(): string {
            return this.station?.type;
        },

    }
});